<template>
    <div>
        <!-- <ValidationObserver v-slot="{ handleSubmit, errors }"> -->
            
                            <!-- @submit.prevent="handleSubmit(saveEdit)" -->
            <!-- <form @submit.prevent="handleSubmit(saveEdit)"> -->
                <CCard>

                    <CCardHeader class="bgcolor grey-header d-flex">
                        <CRow class="exchangeRateTable flex-flow-column">
                            <CCol>
                                <strong>{{ $t("exchngRt.title") }}</strong>
                            </CCol>
                            <p class="desc">
                                {{ $t("exchngRt.desc") }}
                            </p>
                        </CRow>
                        <div @click="toggleJsonExcelModal()" class="generate-ex-btn" v-if="exchngRes.length > 0">
                            <img
                                    src="@imgPath/img/svg/icons/excle-icon.svg"
                                    alt=""
                            />
                        </div>
                    </CCardHeader>
                    <ValidationObserver v-slot="{ handleSubmit}">
                    <form @submit.prevent="handleSubmit(saveEdit)">
                    <CCardBody class="pb-0px" >
                         
                        <cTable
                                :items="exRateComputedList"
                                :fields="exchngresFields"
                               
                                :loading="isLoading"
                              :sorter='{ external: true, resetable: true }'

              column-filter
             
              hover
              id="user-manage-table"

                                      @filtered-items-change="getFilteredList"
                                      @update-sorter-value="updateSorterValue"
                                      :fullScreen="false"
                        >
                        <template #no-items-view>
                                        <div class="text-center my-5">
                                            <h2 class="no-data-title">{{isLoading?'':exchngRes&&exchngRes.length==0?'No items':'No filtering Results'}}</h2>
                                        </div>
                                    </template>
                            <!-- <template #exrate-header>
                                <div class="">{{ $t("exchngRt.exrate") }}</div>
                            </template> -->
                            <template #exrate="{item}">
                                <td class="py-2 ">
                                    <div v-if="isEdit">{{ item.exrate }}</div>
                                    <div v-else>
                                        <!-- <ValidationProvider
                                                tag="div"
                                                name="exrate"
                                                :rules="'_required'"
                                                :label="'exrate'"

                                                v-slot="{ errors }"
                                        > -->
                                            <!-- <cTextInputComponent
                                              v-model="item.exrate"
                                              name="exrate"
                                              :rules="getRules()"
                                              :key="'ex' + index"
                                              class="inner-label-none"
                                              :isRightAlign="true"

                                            /> -->
                                            <!-- required|no_space|no_special_char|only_numbers|validDecimal|maxDecimal|no_zero -->
                                            <cTextInputComponent
                                                    v-model="item.exrate"
                                                    :rules="getRules()"
                                                   :name="'exchangeRate'"
                                                  :vid="item.index+'exrate'"

                                                    :key="'ex' + item.index"
                                                    class="inner-label-none"
                                                    :isRightAlign="true"

                                            />
                                            <!-- <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                                <span>{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider> -->
                                        <!-- @change="getExchangeRate" -->
                                    </div>
                                </td>
                            </template>

                            <!-- <template #created_at-header>
                                <div>{{ $t("exchngRt.lastUpdtd") }}</div>
                            </template> -->
                            <template #created_at="{item}">
                                <td class="">
                  <span
                          v-c-tooltip.hover="{
                      content: `${showTooltip(item.created_at)}`
                    }"
                  >{{ item.created_at  }}</span
                  >
                                </td>
                                <!-- <span  v-c-tooltip="{content:showTooltip(item.created_at),active:true}" >{{item.created_at |timeAgoFormat}}</span> -->
                            </template>
                        </cTable>
                    </CCardBody>
                    <CCardFooter class="d-flex justify-content-end">
                        <!-- <div v-if="isExportTable" class="excel-download">
                          <div v-if="jsonData">

                        <CButton>

                        </CButton>



                              <JsonExcel
                              :data="jsonData"
                              :fields="jsonFields"
                              worksheet="ExchangeRate"
                              name="ExchangeRate.xls"
                              >{{ $t("exchngRt.download") }}</JsonExcel
                            >
                          </div>
                        </div> -->
                        <CRow>
                            <CCol>
                                <div>
                                    <div v-if="isEdit&&filteredList&&filteredList.length>0">
                                        <CButton

                                                @click="onEdit"
                                                color="info"

                                                class="action-c-btn ml-auto ml-10px"
                                        >
                                            <img
                                                    src="@imgPath/img/svg/icons/edit.svg"
                                                    class="filter-inherit"
                                            />
                                            {{ $t("exchngRt.editBtn") }}
                                        </CButton
                                        >
                                    </div>
                                    <div v-if="!isEdit&&filteredList&&filteredList.length>0" id="exchange-edit-btn">
                                        <CButton

                                                style="margin-right: 16px"
                                                color="danger"
                                                @click="toggleEdit"
                                        >{{ $t("exchngRt.backBtn") }}
                                        </CButton
                                        >

                                        <CButton type="submit" color="success">{{
                                            $t("exchngRt.saveBtn")
                                            }}
                                        </CButton>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                    </CCardFooter>
                     </form>
                     </ValidationObserver>
                </CCard>
           
        

        <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p v-for="(value,index) in alertValue.valueList" :key="index">
                    {{value}}
                </p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{$t("cAlert.errorCode")+' : '}}</span><span v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
                <p>
                    {{alertValue}}
                </p>
            </div>
        </CAlert>
        <cAlertModal
                :buttonList="[
        {
          name: $t('exchngRt.okBtn'),
          func: navigateToExchangeRate,
          color: 'success'
        }
      ]"
                :status="1"
                :show="showAlertModal"
                :desc="$t('exchngRt.updateSuccess')"
        ></cAlertModal>
        <div>
            <cJsonExcelModal
                    v-if="showJsonExcelModal"
                    :show="showJsonExcelModal"
                    :desc="$t('jsonExcelModal.desc', { name: $t('exchngRt.title') })"
                    :onCancel="toggleJsonExcelModal"
            >
                <template #jsonExcel>
                    <div @click="toggleJsonExcelModal()">
                        <cExportExcel
                                :data="jsonData"
                                :fields="jsonFields"
                                worksheet="ExchangeRate"
                                :name="getExcelFileName($t('exchngRt.title'))"
                        >{{ $t("jsonExcelModal.download") }}
                        </cExportExcel
                        >
                    </div>
                </template>
            </cJsonExcelModal>
        </div>

        <cAlertModal v-if="isTestAlert"
                     :buttonList="[
      { name:$t('ticketNowPage.okBtn'),func: onToggelTestAlert,color: 'danger'},]"
                     :show="isTestAlert"
                     :status="0"
                     :desc="alertValueDes"
        ></cAlertModal>
        <!--    <button @click="onShowTestAlert">Test</button>-->
<!--        <div id="2VJfKh-fp" role="status" aria-live="polite" aria-atomic="false" class="toasted-container bottom-right"><div class="toasted toasted-primary info" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1; transform: translateY(-35px);">Searching<i aria-hidden="true" class="cil-reload after"></i></div></div>-->
    </div>
</template>

<script>
    import Vue from "vue";
    import router, {navigate, goBack,updateDataEdited} from "../router/index";

    import {mapGetters, mapActions} from "vuex";

    import {ValidationObserver, ValidationProvider, localize} from "vee-validate";

    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES
    } from "../config/API_DATA";
    import BaseConfiguration from "../config/base";
    import {PATHNAME, COMPONENT_NAME,ORDER,DATE_TIME_FORMAT} from "../../src/util/constants";
    import cAlertModal from "../components/form/cAlertModal";
    import cTextInputComponent from "../components/form/cTextInputComponent";
    import apiExchangeRateDetails from "../services/apiExchangeRateDetails";
    import apiSaveExchangeRate from "../services/apiSaveExchangeRate";
    import Logger from "../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../util/apiValidate";
    import {handleJWT, getErrorAlertValue, addClassToBody, removeClassBody,OrderByList,OrderBy, cloneData, cloneDeep} from "../util/util";
    // import nb from "../translations/validation/nb.json";
    // import en from "../translations/validation/en.json";
    //import JsonExcel from "vue-json-excel";
  import  cExportExcel from './../components/excel/cExportExcel'
    import cJsonExcelModal from "./../components/modal/cJsonExcelModal";

    import {formatDate} from "../util/date/dateFunctions";
  import cTable from "../components/dataTable/cTable";

    export default {
        name: COMPONENT_NAME.EXCHANGE_RATE,

        components: {
            ValidationObserver,
            cTextInputComponent,
            cAlertModal,
            ValidationProvider,
           
            cExportExcel,
            cJsonExcelModal,
            cTable
        },

        data() {
            return {
                oriExchngRes: [],
                exchngRes: [],
                exchngresFields: [],
                //exRateLimit: BaseConfiguration.exrateMaxLimit,
                isEdit: true,

                showJsonExcelModal: false,
                alertValue: null,
                //showAlert: false,
                showAlertModal: false,
                isExportTable: false,
                jsonData: null,
                jsonFields: null,
                isTestAlert: false,//test
                alertValueDes: null,
                filteredList:[],
                isLoading:true
            };
        },
        computed:{
               //for filtering created_at
       exRateComputedList () {
             let retValue=[];
             let exchngRes=cloneDeep(this.exchngRes)
             exchngRes.forEach(item => {
              if (item){    
                item.created_at=this.$options.filters.timeAgoFormat(item.created_at);
                retValue.push(item)
                }
               });
              return retValue;
         },
        },

        methods: {
            ...mapActions("sExchangeRate", ["SET_EXCHANGE_RATE_REQUEST"]),
            ...mapActions("sExchangeRate", ["SET_EXCHANGE_RATE_RESPONSE"]),
            ...mapActions("sExchangeRate", ["SET_SAVE_EXCHANGE_RATE_REQUEST"]),
            ...mapActions("sExchangeRate", ["SET_SAVE_EXCHANGE_RATE_RESPONSE"]),
            ...mapActions("sExchangeRate", ["CLEAR_EXCHANGE_RATE_STORE"]),

     updateSorterValue(pSorterValue) {
         try {
           if(BaseConfiguration.isDebug) console.log("updateSorterValue");
           if(pSorterValue&&pSorterValue.column){
          this.exchngRes=OrderBy(this.exchngRes,pSorterValue.column,pSorterValue.asc?ORDER.ASC:ORDER.DESC);
           }else{
          this.exchngRes=this.oriExchngRes;

           }

     
         } catch (err) {
                 let body = Logger.buildRequest(
                   FILE_NAME.EXCHANGE_RATE,
                   "error in updateSorterValue",
                   err.toString(),
                   "updateSorterValue",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           
         }, 

          getFilteredList(pFilteredItems) {
              try {
                if(BaseConfiguration.isDebug) console.log("getFilteredList");
                   this.filteredList=pFilteredItems;

              } catch (err) {
                      let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in getFilteredList",
                        err.toString(),
                        "getFilteredList",
                        LOG_TYPE.ERROR
                      );
                      Logger.getResponse(body);
                    }
              }, 
            onEdit() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onEdit");
                let exchangeRes = this.exchngRes
                 for (let i = 0; i < exchangeRes.length; i++) {
                    exchangeRes[i]["index"]=i; 
                }

                this.toggleEdit();
                 updateDataEdited(true); 
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.EXCHANGE_RATE,
                          "error in onEdit",
                          err.toString(),
                          "onEdit",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 
                }, 
                 getExcelFileName(pFileName) {
                                  let retValue;

                try {
                  if(BaseConfiguration.isDebug) console.log("getExcelFileName");
                    let excelDate=this.$options.filters.formatDate(new Date()); 
                    retValue=pFileName+' - '+excelDate+'.xlsx';
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.EXCHANGE_RATE,
                          "error in getExcelFileName",
                          err.toString(),
                          "getExcelFileName",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 


            onToggelTestAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onToggelTestAlert");
                    this.isTestAlert = !this.isTestAlert;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXCHANGE_RATE,
                        "error in onToggelTestAlert",
                        err.toString(),
                        "onToggelTestAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onShowTestAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onShowTestAlert");
                    let errorAlert = {
                        codeList: ['SES08', 'SES09', 'SES07'],
                        valueList: ['Pricing failed. Please select different flight and try again', 'The flight is currently unavailable. Please try another flight',
                            'The flight is currently unavailable.']
                    }


                    let toastOption = {
                        duration: 3000,
                        position: "bottom-right",
                        icon: {
                            name: "cil-reload",
                            after: true
                        },
                        action: null
                    }
                    Vue.toasted.clear();
                    Vue.toasted.error(
                        errorAlert.valueList.toString() + errorAlert.codeList.toString()
                        , toastOption);

////
                    this.alertValueDes = errorAlert;
                    this.isTestAlert = true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXCHANGE_RATE,
                        "error in onShowTestAlert",
                        err.toString(),
                        "onShowTestAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getRules() {
                if (BaseConfiguration.isDebug) console.log("getRules");
                return (
                    "required|no_space|no_special_char|only_numbers|validDecimal|maxDecimal|no_zero"
                );
            },

            showAlert(value) {
                if (BaseConfiguration.isDebug) console.log("showAlert");
                this.alertValue = value;
            },

            toggleJsonExcelModal() {
                this.showJsonExcelModal = !this.showJsonExcelModal;
            },

            showTooltip(pDate) {
                if (pDate) pDate = formatDate(new Date(pDate),DATE_TIME_FORMAT.DATE_TIME_MERIDIAN);
                return pDate;
            },

            getFields: function (pRes) {
                if (BaseConfiguration.isDebug) console.log("getFields");
                // let keyList = [];
                try {
                     return [

        {
          key: "from_currency",
          label: this.$t("exchngRt.fromCurrency"),
          sorter: true,
            isLocked:true
        },
        {
          key: "to_currency",
          label:this.$t("exchngRt.toCurrency"),
           sorter: true,
            isLocked:true
        },

        {
          key: "exrate",
          label: this.$t("exchngRt.exrate"),
           sorter: true,
            isLocked:true
        },
        {
          key: "created_at",
          label: this.$t("exchngRt.lastUpdtd"),
           sorter: true,
            isLocked: false
        },
                     ]
                    // if (pRes && pRes.length > 0 && pRes[0]) {
                    //     //for(let item=0;item<pRes[0].length;item++)
                    //     /*for (let item=0;item<Object.keys(myItem).length;item++) {
                    //                   keys.push(item);
                    //               }*/

                    //     let resItem = pRes[0];

                    //     for (let item in resItem) {
                    //         let keyObj = {
                    //             key: item
                    //         };

                    //         keyList.push(keyObj);
                    //     }
                    // }
                    // return keyList;
                } catch (e) {
                    let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in  getFields for Exchange Rate",
                        err.toString(),
                        "getFields()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            // getFields: function() {
            //   return [
            //     {
            //       key: "from_currency"
            //     },
            //     {
            //       key: "to_currency"
            //     },
            //     {
            //       key: "exrate"
            //     },
            //     {
            //       key: "last_updated"
            //     }
            //   ];
            // },

            getJsonData(exRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getJsonData");
                    let jData = [];
                    if (exRes) {
                        jData = JSON.parse(JSON.stringify(exRes));
                        this.jsonFields = {
                            "From Currency": "from_currency",
                            "To Currency": "to_currency",
                            "Exchange Rate": "exrate",
                            "Last Updated": {
                                field: "created_at",
                                callback: value => {
                                    return formatDate(new Date(value),DATE_TIME_FORMAT.DATE_TIME_MERIDIAN);
                                }
                            }
                        };
                        return jData;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in getJsonData",
                        err.toString(),
                        "getJsonData",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            navigateToExchangeRate() {
                if (BaseConfiguration.isDebug) console.log("navigateToExchangeRate");

                try {
                    this.showAlertModal = false;
                    //this.exchngRes = JSON.parse(JSON.stringify(this.exchngRes)) ;

                    navigate(PATHNAME.DASHBOARD);
                } catch (e) {
                    let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in  navigate To Exchange Rate",
                        err.toString(),
                        "navigateToExchangeRate()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async createExchngRes() {
                if (BaseConfiguration.isDebug) console.log("createExchngRes");

                let retValue;

                try {
                    let createExchngRequest = apiExchangeRateDetails.buildRequest();

                    if (createExchngRequest != null) {
                        this.SET_EXCHANGE_RATE_REQUEST(createExchngRequest);

                        let createExchngResponse = await apiExchangeRateDetails.getResponse(
                            createExchngRequest
                        );
                        if (VALIDATE_SUCCESS_RES(createExchngResponse)) {
                            retValue = createExchngResponse.data.data;

                            this.SET_EXCHANGE_RATE_RESPONSE(retValue);
                            this.showAlert(null);
                        } else {
                            // this.showAlert = true;

                            let error = getErrorMessage(createExchngResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in  getting Exchange Response",
                        err.toString(),
                        "createExchngRes",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            async saveEdit() {
                if (BaseConfiguration.isDebug) console.log("saveEdit");
                let retValue;
                try {  
                    let req = JSON.parse(JSON.stringify(this.exchngRes));



                    let saveExchngRequest = apiSaveExchangeRate.buildRequest(req);

                    if (saveExchngRequest != null) {

                             if(saveExchngRequest && saveExchngRequest.length)
                             {
                                 saveExchngRequest.forEach(value=>{

                                     if(value && value.exrate<=0)
                                     {
                                         throw "Exchange Rate must be greater than zero"
                                     }
                                 })
                             }

                        this.SET_SAVE_EXCHANGE_RATE_REQUEST(saveExchngRequest);

                        let saveExchngResponse = await apiSaveExchangeRate.getResponse(
                            saveExchngRequest
                        );
                        if (VALIDATE_SUCCESS_RES(saveExchngResponse)) {
                            retValue = saveExchngResponse.data.data;

                            this.SET_SAVE_EXCHANGE_RATE_RESPONSE(retValue);

                            this.toggleEdit();
                            this.showAlertModal = true;
                            this.showAlert(null);
                        } else {
                            // this.showAlert = true;

                            let error = getErrorMessage(saveExchngResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                     updateDataEdited(false); 
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in  updating Exchange Response",
                        err.toString(),
                        "saveExchngResponse",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            async toggleEdit() {
                if (BaseConfiguration.isDebug) console.log("toggleEdit");
                this.showAlert(null);
                this.isEdit = !this.isEdit;
                if (this.isEdit == true) {
                    this.exchngRes = [];
                    this.exchngRes = await this.createExchngRes();
                    //this.exchngRes = JSON.parse(JSON.stringify(this.oriExchngRes));
                }
            },

            getExchangeRate(pExrate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getExchangeRate");
                    //let retValue;
                    for (let index = 0; index < this.exchngRes.length; index++) {
                        const exrate = this.exchngRes[index];
                        if (exrate.from_currency == pExrate.from_currency && exrate.to_currency == pExrate.to_currency) {
                            exrate.exrate = pExrate.exrate;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.EXCHANGE_RATE,
                        "error in getExchangeRate",
                        err.toString(),
                        "getExchangeRate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

            exportTable() {
                if (BaseConfiguration.isDebug) console.log("exportTable");
                this.isExportTable = true;
            },
             getPropToSortExchngeRes(pExchngeRes) {
         try {
           if(BaseConfiguration.isDebug) console.log("getPropToSortExchngeRes");
          if(pExchngeRes.from_currency){
            return pExchngeRes.from_currency.toLowerCase();
          }
     
         } catch (err) {
                 let body = Logger.buildRequest(
                    COMPONENT_NAME.EXCHANGE_RATE,
                   "error in getPropToSortExchngeRes",
                   err.toString(),
                   "getPropToSortExchngeRes",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           
         },
        },

        created: async function () {
            if (BaseConfiguration.isDebug) console.log("created");
            this.oriExchngRes = await this.createExchngRes();
                    this.oriExchngRes=OrderByList(this.oriExchngRes,this.getPropToSortExchngeRes,ORDER.ASC);

            //apiExchangeRateDetails.cancelResponse();
            if (this.oriExchngRes) {
                this.exchngRes = JSON.parse(JSON.stringify(this.oriExchngRes));
                this.exchngresFields = this.getFields(this.exchngRes);
                this.jsonData = this.getJsonData(this.exchngRes);
            }
            this.isLoading=false;
        },

      beforeCreate() {
            addClassToBody(COMPONENT_NAME.EXCHANGE_RATE);
        },

        beforeDestroy() {
            removeClassBody();
        },
    };
</script>
